<template>

  <b-modal :id="modalId" size="xl" centered @hidden="hide" @shown="shown" modal-class="modal-digital-items"
           :footer-class="'justify-content-center'">
    <!-- OVERLAY FOR MOBILE DOWNLOAD -->
    <overlay :show="displayDownload" @click="displayDownload=false"></overlay>
    <template v-slot:modal-header class="text-left justify-content-start">
      <div class="fraction">{{ realIndex }}/{{ totalMedias }}</div>
      <div class="close" @click="hide"></div>
      <!-- CONTEXT MENU -->
      <checkin-menu-media
          v-if="!isPaid && currentMedia && !currentMedia.is_public"
          :photoId="currentMedia.id"
          @remove-photo="$bvModal.show('modal-remove-media')"/>
    </template>
    <span v-touch:swipe.bottom="onSwipeBottom">
        <swiper-slider :has-navigation="true"
                       :extra-class="'slider-photo-gallery'"
                       :selected-index="selectedIndex"
                       :zoom="true"
                       :simulate-touch="false"
                       :page="page"
                       ref="swiperSlider"
                       :loop="!mediasArePaginated"
                       @swiper-init="onSwiperInit"
                       @slide-change="onSlideChange">
          <template v-slot:slides>
            <div class="swiper-slide" v-for="(slide, index) in medias" :key="index" :data-index="index">
              <div class="swiper-zoom-container swiper-item">
                <vue-plyr v-if="slide.media_type===mediaTypes.VIDEO" class="w-100" :ref="'video-' + index">
                   <video :data-poster="slide.image_url" :src="slide.download_hd_url || slide.video_preview_url">
                     <source :src="slide.download_hd_url || slide.video_preview_url" :type="mimeType" size="720">
                  </video>
                </vue-plyr>

                <img :data-src="slide.image_url" alt="" class="swiper-lazy" v-else>
              </div>
            </div>
          </template>
        </swiper-slider>
    </span>
    <template v-slot:modal-footer>
      <!-- MOBILE DOWNLOAD BUTTONS -->
      <template v-if="isPaid">
        <div class="d-flex align-items-center">
          <CartActions :media="currentMedia"
                       :digital-item-id="digitalItemId"
                       :gallery="gallery"
                       v-if="currentMedia"/>
        </div>
      </template>
      <template v-else>
        <div class="d-flex justify-content-center download-container-mobile d-block d-md-none"
             :class="{'on': displayDownload}">
          <ul class="nav nav-pills align-items-center flex-column w-100">
            <li class="nav-item mb-4"><h4>{{ $t('collage_photo_item.download_sd_tooltip') }}</h4></li>
            <li class="nav-item mb-3" v-if="currentMedia && (currentMedia.download_sd_url || currentMedia.download_hd_url)">
                <DownloadActions :media="currentMedia"
                                 is-mobile
                                 @click="trackShare('download');displayDownload=false"
                                 v-if="currentMedia" />
            </li>
            <li class="nav-item">
              <b-button variant="light" @click="displayDownload=false">{{ $t('photo_chooser.action_close') }}</b-button>
            </li>
          </ul>
        </div>
        <div class="d-flex action-container" v-if="currentMedia">
          <div class="wrap-sharing" :class="{'on': displaySharing}">
            <ul class="nav share-tool">
              <li class="nav-item">
                <a href="#" class="nav-link" @click.prevent="displaySharing=false">
                  <div class="icon-bg">
                    <Icon name="arrowLeft" width="26"/>
                  </div>
                  <div class="name">&nbsp;</div>
                </a>
              </li>
              <li>
                <CopyText :clipboard="currentMedia.share_url.replace('[network]', 'clipboard')"
                          :confirm-title="$t('pages.checkins_detail.copied_title')"
                          :confirm-message="$t('pages.checkins_detail.copied_text')"/>
              </li>
              <li class="nav-item" v-for="(network, index) in socialNetworksList" :key="index">
                <Sharer :event-name="eventName"
                        :url-to-share="currentMedia.share_url"
                        :network="network"
                        @click="trackShare(network)"/>
              </li>
            </ul>
          </div>
          <!-- DOWNLOAD DESKTOP -->
          <div class="wrap-sharing d-none d-md-block w-100" :class="{'on': displayDownload}">
            <div class="row align-items-center justify-content-center">
              <div class="col-md-8 col-lg-6">
                   <DownloadActions :media="currentMedia"
                                    @click="trackShare('download');displayDownload=false"
                                    v-if="currentMedia" />
              </div>
              <div class="col-md-auto">
                <a href="#" @click.prevent="displayDownload=false">
                  <Icon name="close" width="26"/>
                </a>
              </div>
            </div>
          </div>

          <div class="wrap-actions" :class="{'off': displaySharing || displayDownload}"
               v-if="currentMedia && currentMedia.share_url">
            <ul class="nav share-tool">
                 <li class="nav-item" v-if="!isPaid && favoriteEnabled">
               <FavoriteAction :media="currentMedia" @toggle-favorite="onToggleFavorite"/>
              </li>

              <li class="nav-item" v-if="isSharingEnabled">
                <a href="#" class="nav-link icon-send" @click.prevent="displaySharing=true;">
                  <div class="icon-bg">
                    <Icon name="send" width="26"/>
                  </div>
                </a>
              </li>
              <li class="nav-item" v-if="currentMedia && currentMedia.is_social_editor_enabled">
                <b-popover tabindex="0" boundary="viewport" boundary-padding="10" :container="modalId"
                           target="popover-customize" placement="top" triggers="hover"
                           ref="popoverStickers">
                  <a :href="getStoreUrl()" target="_blank" class="d-block">
                    <div class="d-flex balloon align-items-start">
                      <img class="balloon__logo" :src="require('@/assets/pica-icon.svg')">
                      <div class="balloon__text">
                        <h5 class="balloon__title">{{ $t('collage_photo_item.balloon_title') }}</h5>
                        <h6 class="balloon__sub-title">{{
                            $t('collage_photo_item.balloon_subtitle')
                          }}</h6>
                      </div>
                    </div>
                  </a>
                </b-popover>

                <a :href="getStoreUrl()" class="nav-link" id="popover-customize" target="_blank">
                  <div class="icon-bg">
                    <Icon name="grStars" width="26"/>
                  </div>
                </a>

              </li>
            </ul>

            <ul class="nav share-tool">
               <li class="nav-item">
                <a href="#" class="nav-link icon-share" @click.prevent="displayDownload=true;">
                  <div class="icon-bg">
                    <Icon name="download" width="26"/>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </template>
    <ModalRemoveMedia :media-id="currentMedia.id" v-if="!isPaid && currentMedia"
                      @media-removed="onMediaRemoved($event)"/>
  </b-modal>
</template>


<script>
import SwiperSlider from "@/components/SwiperSlider.vue";
import Overlay from "@/components/interface/fragments/Overlay.vue";
import {APP_STORES_URL, getMobileOS, MOBILE_OS} from "@/utils";
import ModalRemoveMedia from "@/components/ModalRemoveMedia.vue";
import CheckinMenuMedia from "@/components/CheckinMenuMedia.vue";
import metric_message from "@/domain/metrics/message";
import Gallery from "@/domain/metrics/gallery";
import Sharer from "@/domain/checkinDetail/Sharer.vue";
import {socialNetworksList} from "@/domain/checkinDetail/constants";
import CopyText from "@/domain/core/CopyText.vue";
import {mapGetters} from "vuex";

import CartActions from "@/domain/galleries/medias/CartActions.vue";
import {galleryTypes, mediaQuality, mediaTypes, paginationType} from "@/domain/galleries/constants";
import FavoriteAction from "@/domain/galleries/medias/FavoriteAction.vue";
import DownloadActions from "@/domain/galleries/medias/DownloadActions.vue";

export default {
  name: 'ModalMedia',
  emits: ['media-removed', 'nextPage'],
  components: {
    DownloadActions,
    FavoriteAction,
    CartActions,
    CopyText,
    Sharer,
    CheckinMenuMedia,
    ModalRemoveMedia,
    SwiperSlider,
    Overlay,
  },


  props: {
    modalId: {
      type: String,
      required: false,
      default: 'modal-media'
    },
    medias: {
      type: Array,
      required: true
    },
    totalMedias: {
      type: Number,
      required: false
    },
    page: {
      type: Number,
      required: false,
    },
    isPaid: {
      type: Boolean,
      required: false
    },
    digitalItemId: {
      type: Number,
      required: false
    },
    mimeType: {
      type: String,
      default: 'video/mp4'
    },
    gallery: {
      type: Object,
      required: false
    },
    paginationMode: {
      type: String,
      required: false,
      default: paginationType.INFINITE
    },
    galleryType: {
      type: String,
      required: false
    },
    favoriteEnabled: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      currentMedia: null,
      selectedIndex: 0,

      // interface interactions
      displaySharing: false,
      displayDownload: false,
      showDownloadOverlayForMobile: false,

      justOpened: true,
      playingVideo: null
    }
  },

  watch: {
    medias: {
      handler() {
        this.setCurrentMedia(this.medias[this.selectedIndex])
      },
      deep: true
    }
  },

  computed: {
    mediaQuality() {
      return mediaQuality
    },
    ...mapGetters('checkinDetail', [
      'eventName', 'shareMode', 'hdAvailableFrom'
    ]),

    mediasArePaginated() {
      return this.page !== undefined
    },
    socialNetworksList() {
      return socialNetworksList.sort((a, b) => a.name.localeCompare(b.name))
    },
    isSharingEnabled() {
      return this.shareMode !== null && !this.$store.getters['appConfig/isRunningInWebview']
    },
    realIndex() {
      return this.selectedIndex + 1
    },
    mediaTypes() {
      return mediaTypes
    }
  },

  methods: {
    shown() {
      document.getElementById(this.modalId).addEventListener('click', e => {
        this.showHidePopoverStickers(false)
      });
      this.showHidePopoverStickers(true, 1000)
    },

    show(index) {
      this.justOpened = true
      this.$set(this, 'selectedIndex', index)
      this.setCurrentMedia(this.medias[index])
      this.$bvModal.show(this.modalId)
    },

    hide() {
      this.$bvModal.hide(this.modalId)
      this.resetCurrentMedia()
      setTimeout(() => {
        this.displaySharing = false
        this.displayDownload = false
      }, 500)
    },

    onToggleFavorite() {
      if (this.galleryType === galleryTypes.FAVORITE) {
         this.hide()
      }
    },

    onSwiperInit() {
      // if exists set the first video as playing
      if (this.currentMedia && this.currentMedia.media_type === mediaTypes.VIDEO) {
        if (this.$refs[`video-${this.selectedIndex}`]) {
          this.playingVideo = this.$refs[`video-${this.selectedIndex}`][0].player
          this.playingVideo.play()
        }
      }
    },
    onSlideChange(selectedIndex, slide) {
      const media = this.medias[selectedIndex]
      this.setCurrentMedia(media)
      Gallery.mediaOpened(this.currentMedia.id)

      // stop video when changing slide
      if (this.playingVideo) {
        this.playingVideo.pause()
      }
      if (this.$refs[`video-${selectedIndex}`]) {
        if (slide.previousIndex !== undefined && this.$refs[`video-${slide.previousIndex}`]) {
          this.playingVideo = this.$refs[`video-${selectedIndex}`][0].player
          //this.playingVideo.play()
        }
      }

      // The first photo opened was viewed from the gallery, when we scroll the gallery we count it as view
      // to avoid "more open than view" problem
      if (this.justOpened) this.justOpened = false
      else Gallery.mediaViewed(this.currentMedia.id)
      this.$set(this, 'selectedIndex', selectedIndex)

      this.showHidePopoverStickers(false)

      if (this.mediasArePaginated) {
        if (this.paginationMode === paginationType.NUMBER) return
        if (selectedIndex === this.medias.length - 2 || selectedIndex === this.medias.length - 1) {
          this.$emit('nextPage')
        }
      }
    },

    setCurrentMedia(media) {
      this.currentMedia = media
    },

    resetCurrentMedia() {
      this.currentMedia = null
    },

    trackShare(network) {
      metric_message.createShareIntent(this.currentMedia.id, network.name)
    },

    onSwipeBottom() {
      this.$bvModal.hide(this.modalId)
    },
    showHidePopoverStickers(open, timeout = 0) {
      if (this.$refs.popoverStickers) {
        setTimeout(() => {
          this.$refs.popoverStickers.$emit(open ? 'open' : 'close')
        }, timeout)
      }
    },
    getStoreUrl() {
      let url = APP_STORES_URL.appStore // default
      let os = getMobileOS()
      if (os === MOBILE_OS.android) {
        url = APP_STORES_URL.playStore
      }
      return url
    },
    onMediaRemoved(mediaId) {
      this.$emit('media-removed', mediaId)
      this.$bvModal.hide(this.modalId)
    }
  }
}
</script>
